<div
  *ngIf="event"
  [style]="'--bg-color:' + (event.color || '#3158e3')"
  class="wrapper text-color-{{ getContrastYIQ(event.color || '#3158e3') }}"
>
  <div class="container">
    @if (!rejected) {
      <header class="text-center" [class.d-none]="submitted">
        <div class="heading mb-3" *ngIf="event.with_picture">
          <cf-avatar
            *ngIf="event.picture as picture"
            [src]="$any(picture.image)"
            [rounded]="$any(picture.rounded)"
            size="xl"
          ></cf-avatar>
          <cf-avatar *ngIf="!event.picture" [userName]="event.organizer_name" size="xl"></cf-avatar>
        </div>

        <h2 class="mb-0">{{ event.summary || event.public_title }}</h2>

        <cf-text weight="500" size="lg" color="white" *ngIf="!hideDescription"> {{ eventDescription }} </cf-text>

        <cf-booking-information
          *ngIf="!hideDescription"
          [label]="'booking.former_time' | translate"
          [day]="event.start"
          [time]="eventTime"
          [timezone]="event.timezone"
          [duration]="event.duration | duration"
          [direction]="(isTouch$ | async) ? 'column' : 'row'"
          class="text-force-white ps-xl-5 pe-xl-5 bg-white-70 rounded-3 mt-3 p-3"
        ></cf-booking-information>

        <a
          *ngIf="isTouch$ | async"
          cf-link
          color="white"
          [underlined]="true"
          class="mt-12"
          (click)="hideDescription = !hideDescription"
        >
          @if (hideDescription) {
            {{ "show" | translate }} {{ "booking.description_and_former" | translate }}
          } @else {
            {{ "hide" | translate }} {{ "booking.description_and_former" | translate }}
          }
        </a>

        <cf-booking-information
          *ngIf="selectedSlot && (isTouch$ | async)"
          [label]="'booking.reschedule_to' | translate"
          [day]="selectedSlot.date"
          [time]="selectedTime"
          [timezone]="timezone"
          [duration]="selectedDuration"
          class="text-force-white mt-4"
        ></cf-booking-information>

        <cf-booking-steps
          (emitStep)="stepChange($event)"
          class="d-block mt-4"
          *ngIf="isTouch$ | async"
          [stepIndex]="stepIndex"
        ></cf-booking-steps>
      </header>
    }

    <section
      cf-loader-container
      *ngIf="timeslots"
      [class.personal-information]="selectedTime || rejected"
      [class.submitted]="submitted"
      [class.m-auto]="rejected"
    >
      <ng-container *ngIf="!submitted && !rejected">
        <ng-container *ngIf="!selectedTime">
          <div class="step" [class.m-auto]="!selectedSlot" *ngIf="!selectedSlot || (isTouch$ | async) === false">
            <div class="step-header">
              <div class="tw:text-base tw:lg:text-lg tw:font-medium tw:text-gray-80">
                <div class="tw:block tw:text-sm tw:font-medium tw:text-gray-70" *ngIf="isTouch$ | async">
                  {{ "step" | translate }} 1 {{ "out_of" | translate }} 3
                </div>
                {{ "booking.select_new_date" | translate }}
              </div>
            </div>
            <cf-booking-calendar
              [day]="event.start"
              [selected]="selectedDate"
              [timeslots]="timeslots"
              [isTouch]="isTouch$ | async"
              (emitSlot)="getEvents($event)"
              (emitDateRange)="applyDate($event)"
              [booking]="event"
              bookingType="reschedule"
              [hasFreeSlots]="hasFreeSlots"
            ></cf-booking-calendar>
          </div>

          <ng-container *ngIf="selectedSlot">
            <div class="step ms-xl-5 me-xl-5 hide-scrollbar">
              <div class="step-header">
                <div class="tw:text-base tw:lg:text-lg tw:font-medium tw:text-gray-80">
                  <div class="tw:block tw:text-sm tw:font-medium tw:text-gray-70" *ngIf="isTouch$ | async">
                    {{ "step" | translate }} 2 {{ "out_of" | translate }} 3
                  </div>
                  {{ "booking.select_new_duration_time" | translate }}
                </div>
              </div>
              <cf-booking-picker
                [hasFreeSlots]="hasFreeSlots"
                [isTouch]="isTouch$ | async"
                [formerSlot]="{ start: event.start, end: event.end }"
                [timezoneSetting]="event.timezone_setting || ETimezoneSettings.AUTO_DETECT"
                [hourFormat]="event.time_format"
                [timezone]="timezone"
                [isAuthorized]="authService.isAuthorized$ | async"
                [duration]="event.duration | duration"
                [timeslot]="selectedSlot"
                [durations]="event.meeting_template ? event.meeting_template.durations : [event.duration]"
                [events]="events"
                (emitConfirm)="confirm($event)"
                (emitFocus)="focusTime($event)"
                (emitTimezone)="getTimeslots($event)"
                (emitDuration)="durationChanged($event)"
                (emitNextSlot)="setFreeSlot()"
              ></cf-booking-picker>
            </div>

            <div class="step" *ngIf="(isTouch$ | async) === false">
              <div class="step-header">
                <div class="tw:text-base tw:lg:text-lg tw:font-medium tw:text-gray-80">
                  {{ "booking.see_availability" | translate }}
                </div>
              </div>
              <cf-booking-availability
                [events]="events"
                [date]="selectedSlot.date"
                [isAuthorized]="authService.isAuthorized$ | async"
              ></cf-booking-availability>
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="selectedTime">
          <div class="step personal-information">
            <div class="step-header d-xl-none">
              <cf-text size="lg" weight="600" touchSize="md">
                <cf-text class="d-block" color="grey-70" weight="500" size="sm" *ngIf="isTouch$ | async">
                  {{ "booking.final_step" | translate }}
                </cf-text>
                {{ "booking.reason_for_change" | translate }}
              </cf-text>
            </div>
            <cf-reschedule-reason
              [participants]="participants"
              [form]="form"
              [event]="event"
              [timezone]="timezone"
              [time]="selectedTime"
              [day]="selectedSlot.date"
              [duration]="selectedDuration"
              (emitBack)="back()"
              (emitSubmit)="submit($event)"
            ></cf-reschedule-reason>
          </div>
        </ng-container>
      </ng-container>

      @if (rejected) {
        <div class="d-flex flex-column w-100 text-center">
          <h2 class="mb-1">{{ event.public_title }}</h2>
          <h3>{{ "booking.rejected_notification" | translate }}</h3>
        </div>
      }

      <ng-container *ngIf="submitted">
        <div class="step personal-information">
          <cf-booking-confirmation
            [eventAddedToCalendar]="false"
            heading="{{ 'reschedule' | translate }} {{ 'confirmed' | translate }}"
            description="{{ 'booking.reschedule_confirmation_text' | translate: { name: event.organizer.name } }}"
            [booking]="event"
            [selectedDuration]="selectedDuration"
            [selectedSlot]="selectedSlot"
            [selectedTime]="selectedTime"
            [timezone]="timezone"
            [account]="accountService.account"
            [participantsAmount]="participants.length"
          ></cf-booking-confirmation>
        </div>
      </ng-container>
    </section>

    <cf-booking-footer
      *ngIf="!rejected"
      [isTouch]="isTouch$ | async"
      [showLogo]="event.show_cal_frenzy_logo ?? true"
      [cancellationPolicy]="event.use_cancellation_policy ? (event.cancellation_policy ?? '') : ''"
    ></cf-booking-footer>
  </div>
</div>
